import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { enterSpaceHelper } from "../../../shared/accessibilityHelper";

import Typography from "../../atoms/Typography/Typography";

import "./Chip.scss";

import {
  BiArchive,
  BiChip,
  BiWrench,
  BiTimer,
  BiCertification,
  BiTestTube,
  BiTrophy,
  BiPlus,
} from "react-icons/bi";

const Chip = ({ label, isSelected, selectNew }) => {
  const selected = isSelected ? "chip chip-active" : "chip";
  const selectHandler = () => selectNew(label);

  const getIconsforMenuHandler = useCallback((biIconType) => {
    switch (biIconType) {
      case "Summary":
        return <BiArchive />;
      case "Tech Stack":
        return <BiChip />;
      case "Methodologies":
        return <BiWrench />;
      case "Expiration Date":
        return <BiTimer />;
      case "Credential Id":
        return <BiCertification />;
      case "Project":
        return <BiTestTube />;
      case "Specialization":
        return <BiTrophy />;
      default:
        return <BiPlus />;
    }
  }, []);

  return (
    <div
      className={selected}
      onClick={selectHandler}
      onKeyDown={enterSpaceHelper(selectHandler)}
      role="button"
      tabIndex="0"
    >
      {getIconsforMenuHandler(label)}
      <Typography>{label}</Typography>
    </div>
  );
};

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  selectNew: PropTypes.func.isRequired,
};

export default Chip;
